export const gettext = window.gettext || (msgid => msgid);

export const pgettext = window.pgettext || ((context, msgid) => msgid);

export const interpolate = (fmt, obj, named = true) => (window.interpolate || gettext)(fmt, obj, named);

export const getFormat = window.get_format || (fmt => fmt);

export default gettext;
